import { create } from "zustand";

interface Dimensions {
  width: number;
  height: number;
}

interface AnnotationEditorStore {
  aspectRatio: number;
  container: Dimensions;

  // Actions
  setContainerDimensions: (width: number, height: number) => void;
  setAspectRatio: (ratio: number) => void;
}

export const useAnnotationEditorStore = create<AnnotationEditorStore>((set) => ({
  aspectRatio: 16 / 9,
  container: {
    width: 1920, // Default width for SSR
    height: 1080, // Default height for SSR
  },

  setContainerDimensions: (width: number, height: number) => {
    set({
      container: {
        width,
        height,
      },
    });
  },

  setAspectRatio: (ratio: number) => {
    set({ aspectRatio: ratio });
  },
}));
